import { styled } from '@styledComponents';
import { Button } from '@components/Button';
import { TextPairing } from '@components/TextPairing';
import { Columns } from '@components/Columns';
import { CloudImage } from '@components/CloudImage';
import { themeMediaQuery, themeSpace, themeColor } from '@utils/styledTheme.util';
import { Box } from '@components/Box';
import { TOP_BANNER_HEIGHT } from '@layout';

export const DesktopBoxContainer = styled.div`
  display: block;
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;

export const SiteTemplateLeftBlock = styled.div`
  position: relative;
  height: 56.25vw;

  ${themeMediaQuery('below_sm')} {
    height: auto;
  }
`;

export const VimeoWrapper = styled.div`
  top: ${TOP_BANNER_HEIGHT};
  position: absolute;
  height: 100%;
  width: 100%;
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
`;

export const HeroTextPairing = styled(TextPairing).attrs({
  titleTagName: 'h1',
})<{ id: string }>`
  > .text-pairing-title {
    max-width: 486px;
  }
  .text-pairing-body {
    max-width: 450px;
  }
  ${themeMediaQuery('below_sm')} {
    .text-pairing-title {
      width: 336px;
      color: ${themeColor('neutra6')};
    }
    .text-pairing-body {
      width: 268px;
      color: ${themeColor('neutra5')};
    }
  }
  ${themeMediaQuery('xl')} {
    .text-pairing-title {
      max-width: 550px;
    }
  }
`;

export const TextBlockWrapper = styled(Columns)`
  ${themeMediaQuery('below_sm')} {
    padding-left: 0px;
    padding-right: 0px;
  }
`;

export const StyledBox = styled(Box)`
  ${themeMediaQuery('sm')} {
    width: 100%;
    top: 50%;
    z-index: 1;
    position: absolute;
    transform: translate(0, -13%);
  }
  ${themeMediaQuery('md')} {
    transform: translate(0, -33%);
  }
`;

export const AnimatableButton = styled(Button)`
  ${themeMediaQuery('below_sm')} {
    display: none;
  }
  ${themeMediaQuery('sm')} {
    width: fit-content;
    min-width: 167px;
    display: block;
    padding: 0px 27px;
    &:not(:first-child) {
      margin-top: ${themeSpace(5)};
    }
  }
  ${themeMediaQuery('md')} {
    padding: 0px 32px;
  }
  ${themeMediaQuery('lg')} {
    width: auto;
    display: inline-block;
    &:not(:first-child) {
      margin-left: ${themeSpace(10)} !important;
    }
  }
`;

export const AnimatableButtonMobile = styled(Button)`
  display: none;
  ${themeMediaQuery('below_sm')} {
    display: block;
    width: 50%;
    margin: 0 auto;
  }
`;

export const GettingStartedWrapper = styled.div`
  > *:not(:first-child) {
    margin-left: ${themeSpace(10)};
  }
  ${themeMediaQuery('below_sm')} {
    text-align: center;
    margin-bottom: 60px;
    > *:not(:first-child) {
      margin: 0 auto;
      margin-top: ${themeSpace(6)};
    }
  }
  ${themeMediaQuery('sm')} {
    > *:not(:first-child) {
      margin-left: 0;
    }
  }
  ${themeMediaQuery('lg')} {
    > *:not(:first-child) {
      margin-left: ${themeSpace(10)};
    }
  }
`;

export const MobileCloudImage = styled(CloudImage)`
  ${themeMediaQuery('sm')} {
    display: none;
  }
  ${themeMediaQuery('below_sm')} {
    margin-top: calc(${themeSpace(11)} + ${TOP_BANNER_HEIGHT}px);
    position: relative;
    right: 20px;
    height: auto;
    min-height: 245px;
    width: 100%;
  }
`;

export const BoxContainer = styled(Box)`
  position: relative;
  z-index: 1;
  ${themeMediaQuery('below_sm')} {
    height: auto;
    position: unset;
    z-index: unset;
  }
`;
